// Import Libraries
import React from "react";
import { Col, Row } from "react-bootstrap";

// Initial Styles
const customStyles = {
  lazy: {
    width: "100%",
    height: "40px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
  },
};

/**
 * Description: Component to show lazy loading table for students attendance
 * @returns {JSX.Element}
 */
const StudentsAttendanceLazyLoadingTable = () => {
  return (
    <div>
      <Row className="table-lazyLoading mt-1">
        <Col md={12}>
          <div style={customStyles.lazy}></div>
        </Col>
      </Row>
      <Row className="table-lazyLoading mt-1">
        <Col md={12}>
          <div style={customStyles.lazy}></div>
        </Col>
      </Row>
      <Row className="table-lazyLoading mt-1">
        <Col md={12}>
          <div style={customStyles.lazy}></div>
        </Col>
      </Row>
      <Row className="table-lazyLoading mt-1">
        <Col md={12}>
          <div style={customStyles.lazy}></div>
        </Col>
      </Row>
    </div>
  );
};

// Export Component
export default StudentsAttendanceLazyLoadingTable;
